export default "<p>asistenciaindividual works!</p>\n";